<template>
    <div>
        <template v-for="(template, language) in languageTemplates">
            <template v-if="selectedLanguage === language">
                <component :is="template" :key="language" @add-to-search="addToSearchInput" />
            </template>
        </template>

        <template v-if="!languageTemplates[selectedLanguage]">
            No template selected. selected template: '{{ selectedLanguage }}'
        </template>
    </div>
</template>

<script>

const languageTemplates = {
    nob: () => import('@/components/keyboard/LexinKeyboardLangNob.vue'),
    ara: () => import('@/components/keyboard/LexinKeyboardLangAra.vue'),
    mya: () => import('@/components/keyboard/LexinKeyboardLangMya.vue'),
    prs: () => import('@/components/keyboard/LexinKeyboardLangPrs.vue'),
    fil: () => import('@/components/keyboard/LexinKeyboardLangFil.vue'),
    kmr: () => import('@/components/keyboard/LexinKeyboardLangKmr.vue'),
    ckb: () => import('@/components/keyboard/LexinKeyboardLangCkb.vue'),
    fas: () => import('@/components/keyboard/LexinKeyboardLangFas.vue'),
    pol: () => import('@/components/keyboard/LexinKeyboardLangPol.vue'),
    rus: () => import('@/components/keyboard/LexinKeyboardLangRus.vue'),
    tam: () => import('@/components/keyboard/LexinKeyboardLangTam.vue'),
    ths: () => import('@/components/keyboard/LexinKeyboardLangThs.vue'),
    tir: () => import('@/components/keyboard/LexinKeyboardLangTir.vue'),
    tur: () => import('@/components/keyboard/LexinKeyboardLangTur.vue'),
    urd: () => import('@/components/keyboard/LexinKeyboardLangUrd.vue'),
    vie: () => import('@/components/keyboard/LexinKeyboardLangVie.vue'),
};

export default {
    props: ['selectedLanguage'],

    data() {
        return {
            languageTemplates
        }
    },

    components: {
        TemplateNob: () => import('@/components/keyboard/LexinKeyboardLangNob.vue'),
        TemplateAra: () => import('@/components/keyboard/LexinKeyboardLangAra.vue'),
        TemplateMya: () => import('@/components/keyboard/LexinKeyboardLangMya.vue'),
        TemplatePrs: () => import('@/components/keyboard/LexinKeyboardLangPrs.vue'),
        TemplateFil: () => import('@/components/keyboard/LexinKeyboardLangFil.vue'),
        TemplateKmr: () => import('@/components/keyboard/LexinKeyboardLangKmr.vue'),
        TemplateCkb: () => import('@/components/keyboard/LexinKeyboardLangCkb.vue'),
        TemplateFas: () => import('@/components/keyboard/LexinKeyboardLangFas.vue'),
        TemplatePol: () => import('@/components/keyboard/LexinKeyboardLangPol.vue'),
        TemplateRus: () => import('@/components/keyboard/LexinKeyboardLangRus.vue'),
        TemplateTam: () => import('@/components/keyboard/LexinKeyboardLangTam.vue'),
        TemplateThs: () => import('@/components/keyboard/LexinKeyboardLangThs.vue'),
        TemplateTir: () => import('@/components/keyboard/LexinKeyboardLangTir.vue'),
        TemplateTur: () => import('@/components/keyboard/LexinKeyboardLangTur.vue'),
        TemplateUrd: () => import('@/components/keyboard/LexinKeyboardLangUrd.vue'),
        TemplateVie: () => import('@/components/keyboard/LexinKeyboardLangVie.vue'),
    },

    methods: {
        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
};
</script>
